export const sparePartRequestFormData = () => ({
  inputData: {
    // id: null,
    job_card_id: null,
    spare_id: null,
    quantity: null,

    status: "Pending",
    issue_qty: null,
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "spare_part_requests",
    schema: schema,

    include: [
      {
        model: "job_cards",
        as: "job_card",
      },
      {
        model: "material_masters",
        as: "spare",
      },
      {
        model: "user_masters",
        as: "requested_by_user",
      },
      {
        model: "spare_part_issues",
        as: "issues",
      },
    ],
  };

  const navigatePage = { back: "/spare-part-requests-list" };

  const headerName = "Spare Part Request";

  const validationType = "SparePartRequestsCreate";
  const createEndpoint = "/updaterelationaldata";
  const updateEndpoint = "/updaterelationaldata  ";

  const getEndpoint = "/getRecords";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};


export const listPageData = (type) => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "spare_part_requests",
    schema: schema,

    include: [
      {
        model: "job_cards",
        as: "job_card",
      },
      {
        model: "material_masters",
        as: "spare",
      },
      {
        model: "user_masters",
        as: "requested_by_user",
      },
      {
        model: "spare_part_issues",
        as: "issues",
      },
    ]
  };

 

  const searchfields = [
    "job_card.job_card_no",
    "spare.name",
    "status",
    "requested_by_user.first_name",
    "requested_by_user.last_name",
  ];

  const endpoint = "/getRecords";
  const exportFileName = "SparePartRequestsData.xlsx";

  return {
    payload,
    endpoint,
    searchfields,
    exportFileName,
  };
};